import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "../../../providers/withRouter";
import { Link, useNavigate } from "react-router-dom";
import {
  deleteAAFF,
  getSalesPropsIds,
  sendEmailBienvenida,
  getFincasAAFF,
  getOneAAFF
} from "../../../services";
import Swal from 'sweetalert2';
import { toast } from "react-toastify";
import Delete from "../../../icons/delete.svg";
import Editar from "../../../icons/editar.svg";
import ModalEditar from "./editarDatosAAFF";
import { cambiarFormatoNombre, formatoFechasEs } from "./../../../functions/funciones";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import { TiArrowBack } from "react-icons/ti";
import ListadoComunidades from "./ListadoComunidades";
import { subirListado, eliminarFincas } from "../../../functions/documentacion";
import Chart from "../../../components/Charts/apexCharts";
import { UsuarioContext } from "../../../providers/userContext";
import ObservacionesTecnico from "../../../components/aaff/observacionesTecnico";
import Comentarios from "../../../components/aaff/comentarios";
import { CircularProgress,  } from '@mui/material';
import { MdOutlineMultipleStop } from "react-icons/md";

import Excel from "../../../icons/excel.svg"
import ExportarListaFincasAAFF from "./ExportarListaFincasAAFF";
import ExportarComunidadesSinSenales from "./ExportarComunidadesSinSenales";
import DrawerAsignComunidades from "../../../components/Drawers/DrawerAsignComunidades";
import { set } from "date-fns";
import CrearOficina from "./CrearOficina";
import DrawerChangeEstados from "../../../components/Drawers/DrawerChangeEstado";

const Comunidades = (props) => {
  const { t } = useTranslation(['aaff', 'common']);
  const navigate = useNavigate();
  const user = useContext(UsuarioContext)
  const [aaff, setAAFF] = useState({});
  const [comentarios, setComentarios] = useState();
  const [modalEditarOpened, setModalEditarOpened] = useState(false);
  const [modalCrearOfiOpened, setModalCrearOfiOpened] = useState(false);
  const [recargar, setRecargar] = useState(0);
  const [isLoading, setIsLoading] = useState(true)
  const [show, setShow] = useState(false)
  const [propertiesCae, setPropertiesCae] = useState([])
  const [fincas,setFincas] = useState();
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openDrawerProperties, setOpenDrawerProperties] = useState(false);


  useEffect(() => {
    const refrescarFincas = async () => {
      if (openDrawer === false) {
        const payload = {
          filtros: { aaff_id: aaff.id },
          params: { page: 1, limit: 50 }
        };
        try {
          const misFincas = await getFincasAAFF(payload); // Agregado await
          setFincas(misFincas);
        } catch (error) {
          console.error("Error refrescando fincas:", error);
        }
      }
    };

    fetchData();
    refrescarFincas();
}, [recargar, openDrawer]);

  const fetchData = async ({ offset, limit, filtros } = {}) => {
    //Asier
    const responseAaffs = await getOneAAFF(props.params.nif) || {}
    setAAFF(responseAaffs);
    setComentarios(responseAaffs.comments);
    setIsLoading(false);
    const ids = responseAaffs ? await getSalesPropsIds(responseAaffs?.id) : []
    const payload = {
      filtros:{...filtros, aaff_id: responseAaffs.id},
      params:{page: offset, limit}
    }

    try {
      const response = await getFincasAAFF(payload);
      setFincas(response);

      const resultado = response?.data?.filter(item => ids.includes(item.id) );
      setPropertiesCae(resultado);
    } catch (error) {
      console.error("Error fetching data:", error);
      setFincas({ meta: {}, data: [] });
      setPropertiesCae([]);
    }
  };

  const eliminarAAFF = () =>{
    return new Promise(async (resolve, reject) => {
      try {
        const result = await Swal.fire({
          title: t('confirmations.deleteAaff'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#888",
          cancelButtonText: t('confirmations.cancel'),
          confirmButtonText: t('details.delete')
        });

        if (result.isConfirmed) {
          const toastInfo = toast.info(t('confirmations.deletingAaff'), { autoClose: false });
          await deleteAAFF(aaff.nif).then((res) => {
            if (res.data.message === "AAFF_DELETED") {
              toast.update(toastInfo, {
                render: t('confirmations.deletedSuccess'),
                type: toast.TYPE.SUCCESS,
                autoClose: true
              });
              resolve(true);
              navigate("/aaff")
            } else {
              toast.update(toastInfo, {
                render: t('confirmations.deleteError'),
                type: toast.TYPE.ERROR,
                autoClose: true
              });
            }
          }).catch(error => {
            console.log(error);
            toast.update(toastInfo, {
              render: t('confirmations.deleteError'),
              type: toast.TYPE.ERROR,
              autoClose: true
            });
            reject(error);
          });
        } else {
          // Si el usuario cancela la eliminación
          resolve(false);
        }
      } catch (error) {
        console.error("Error al eliminar el aaff:", error);
        reject(error);
      }
    });

  };

  const handleCallback = () => {
    setRecargar(!recargar);
  };

  const deleteFincas = async () =>  {
    eliminarFincas(aaff).then((resultado) => {
      handleCallback(resultado)
    })
  }

  const handleSendEmail = async () => {
    return new Promise(async (resolve, reject) => {
      try {
        const result = await Swal.fire({
          title: t('confirmations.sendAccessEmail'),
          text: t('confirmations.sendAccessEmailText'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#33dd75",
          cancelButtonColor: "#888",
          confirmButtonText: t('confirmations.send'),
          cancelButtonText: t('confirmations.cancel'),
        });

        if (result.isConfirmed) {
          const toastInfo = toast.info(t('confirmations.sendingAccessEmail'), { autoClose: false });
          await sendEmailBienvenida(user.id, props.params.nif, aaff.razonSocial, aaff.user.email).then((res) => {
            if (res.status === 201) {
              toast.update(toastInfo, {
                render: t('confirmations.sentSuccess'),
                type: toast.TYPE.SUCCESS,
                autoClose: true
              });
              resolve(true);
            } else {
              toast.update(toastInfo, {
                render: t('confirmations.sendError'),
                type: toast.TYPE.ERROR,
                autoClose: true
              });
            }
          }).catch(error => {
            console.log(error);
            toast.update(toastInfo, {
              render: t('confirmations.sendError'),
              type: toast.TYPE.ERROR,
              autoClose: true
            });
            reject(error);
          });
        } else {
          // Si el usuario cancela la eliminación
          resolve(false);
        }
      } catch (error) {
        console.error("Error al enviar email:", error);
        reject(error);
      }
    })

  }
console.log("Fincas state:", aaff);
  return isLoading ? <CircularProgress style={{ color: '#92004D', position: 'absolute', top: '50%', left: '50%' }} /> :
    <>
      <ModalEditar
        aaff={aaff}
        opened={modalEditarOpened}
        handleClose={() => {
          setModalEditarOpened(false);
          setRecargar(!recargar);
        }}
      />
      {user.rol !== "ADMIN_CAI" &&
        <CrearOficina
          opened={modalCrearOfiOpened}
          handleClose={() => {
            setModalCrearOfiOpened(false);
            setRecargar(!recargar);
          }}
          parentId={aaff.id}
        />
    }
      <iframe title="pdf" id="iFramePdf" style={{ display: "none" }}></iframe>
      {/* <div
    className="pageHeader"
    style={{
      backgroundImage: `url(${HeaderBackground})`,
      textAlign: "left",
    }}
  >
    Administrador / <b>{aaff.razonSocial}</b>
  </div> */}
      <BreadCrumb rutas={[{ path: '/aaff', label: t('title') }, { path: '/aaff', label: `${aaff.razonSocial}` }]} style={{ margin: '0 10px' }} />
      <div className="listPage">
        <div className="gridCard">
          <div className="gridHead">
            {t('details.generalInfo')}
            <Link to="/aaff">
              <div className="gridHeadRight">

                <TiArrowBack style={{ fontSize: 23 }} />
              </div>
            </Link>
          </div>
          <div className="gridSubhead editarSubhead">
            <div>{t('details.companyData')}</div>
            <div className="btnsSubhead">
              {(user.rol === "ADMIN" || user.rol === "CONSUL" || user.rol === "VENT") && (
                <div className="editarBtn" onClick={() => setModalCrearOfiOpened(true)} >
                  <span style={{ marginRight: 10 }}>{t('details.createOffice')}</span>{" "}
                  <img src={Editar} alt={t('offices.create')} />
                </div>
              )}
              {user.rol !== "ADMIN_CAI" && (
                <>
                  <div className="editarBtn" onClick={() => setModalEditarOpened(true)} >
                    <span style={{ marginRight: 10 }}>{t('details.edit')}</span>{" "}
                    <img src={Editar} alt={t('common:actions.edit')} />
                  </div>
                  <div className="editarBtn" onClick={eliminarAAFF}>
                    <span style={{ marginRight: 10 }}>{t('details.delete')}</span>{" "}
                    <img src={Delete} alt={t('common:actions.delete')} />
                  </div>
                </>
              )}
            </div>
          </div>
          <div style={{ display: 'flex' }}>
            <div className="datosGrid" style={{ width: '75%' }}>
              <p>
                <b>{t('details.name')}:</b> {aaff.razonSocial}
              </p>
              {!aaff.parent_id && (
                <p>
                  <b>{t('details.nif')}:</b> {aaff.nif}
                </p>
              )}
              {aaff.parent_id && aaff.parent && (
                <p>
                  <b>{t('details.parent')}:</b> {aaff.parent.razonSocial} ({aaff.parent.nif})
                </p>
              )}
              <p>
                <b>{t('details.municipality')}:</b> {cambiarFormatoNombre(aaff.municipio)}
              </p>
              <p>
                <b>{t('details.province')}:</b> {aaff.provincia}
              </p>
              <p>
                <b>{t('details.postalCode')}:</b>  {aaff.codigoPostal}
              </p>
              <p>
                <b>{t('details.contactPerson')}:</b> {aaff.nombreContacto}
              </p>
              <p>
                <b>{t('details.phone')}:</b> {aaff.telefono}
              </p>
              <p>
                <b>{t('details.email')}:</b> {aaff.user?.email}
              </p>
              <p>
                <b>{t('details.contactEmail')}:</b> {aaff.correoContacto}
              </p>
              {aaff?.gruposServicios?.includes(1) &&
                <p>
                  <b>{t('details.consultantCae')}:</b>{" "}
                  {aaff.consultants?.find(item => item.r_consul_servsgroups_aaffs.group_id === 1) ? `${aaff.consultants?.find(item => item.r_consul_servsgroups_aaffs.group_id === 1).nombre} ${aaff.consultants.find(item => item.r_consul_servsgroups_aaffs.group_id === 1).apellidos}` : ''}
                </p>
              }
              {aaff?.gruposServicios?.includes(2) &&
                <p>
                  <b>{t('details.consultantLopd')}:</b>{" "}
                  {aaff.consultants?.find(item => item.r_consul_servsgroups_aaffs.group_id === 2) ? `${aaff.consultants.find(item => item.r_consul_servsgroups_aaffs.group_id === 2).nombre} ${aaff.consultants.find(item => item.r_consul_servsgroups_aaffs.group_id === 2).apellidos}` : ''}
                </p>
              }
              {user.rol !== "ADMIN_CAI" && (
                <p>
                  <b>{t('details.technician')} CAE:</b>{" "}
                  {(() => {
                    const techCae = aaff.technicians?.find(tech => tech.r_tech_aaffs?.group_id === 1);
                    return techCae ? `${techCae.nombre} ${techCae.apellidos}` : "-";
                  })()}{" "}
                </p>
              )}
              <p>
                <b>{t('details.technician')} CAI:</b>{" "}
                {(() => {
                  const techCai = aaff.technicians?.find(tech => tech.r_tech_aaffs?.group_id === 3);
                  return techCai ? `${techCai.nombre} ${techCai.apellidos}` : "-";
                })()}{" "}
              </p>
              {user.rol !== "ADMIN_CAI" && (
                <>
                  <p>
                    <b>{t('details.technician')} KAE:</b>{" "}
                    {(() => {
                      const techKae = aaff.technicians?.find(tech => tech.r_tech_aaffs?.group_id === 4);
                      return techKae ? `${techKae.nombre} ${techKae.apellidos}` : "-";
                    })()}{" "}
                  </p>
                  <p>
                    <b>{t('details.commercial')}:</b>{" "}
                    {aaff.commercial?.nombre !== undefined
                      ? aaff.commercial?.nombre + " " + aaff.commercial?.apellidos
                      : "-"}{" "}
                  </p>
                  <p>
                    <b>{t('details.notificationDate')}:</b>{" "}
                    {aaff.user?.notifiedAt === undefined || aaff.user?.notifiedAt === null
                      ? null
                      : formatoFechasEs(aaff.user?.notifiedAt)}{" "}
                  </p>
                  {/* <p>
                    <b>Fecha de encargo:</b>{" "}
                    {aaff.fechaEncargo === undefined || aaff.fechaEncargo === null
                      ? null
                      : formatoFechasEs(aaff.fechaEncargo)}{" "}
                  </p> */}
                  <p>
                    <b>{t('details.welcomeDate')}:</b>{" "}
                    {aaff.fechaBienvenida === undefined ||
                      aaff.fechaBienvenida === null
                      ? null
                      : formatoFechasEs(aaff.fechaBienvenida)}{" "}
                  </p>
                  <p>
                    <b>{t('details.claimDate')}:</b>{" "}
                    {aaff.fechaReclamacion === undefined ||
                      aaff.fechaReclamacion === null
                      ? null
                      : formatoFechasEs(aaff.fechaReclamacion)}{" "}
                  </p>
                  <p>
                    <b>{t('details.reportDate')}:</b>{" "}
                    {aaff.fechaInforme === undefined || aaff.fechaInforme === null
                      ? null
                      : formatoFechasEs(aaff?.fechaInforme)}{" "}
                  </p>
                </>
              )}
            </div>
            {user.rol !== "ADMIN_CAI" && (
              fincas?.data != undefined && aaff?.gruposServicios?.includes(1) ? <Chart datos={propertiesCae} /> : null
            )}
          </div>
          {user.rol !== "ADMIN_CAI" && (
            <>
              <div className="datosGrid">
                <div></div>
                <div style={{ display: 'flex', justifyContent: 'end' }}>
                  <button onClick={() => handleSendEmail()} style={{ margin: '10px 0', borderRadius: '5px 5px', backgroundColor: '#92004D', color: '#ffffff', padding: '5px 10px' }}>
                    {t('details.sendAccessEmail')}
                  </button>
                </div>
              </div>
            
              <div className="datosGrid">
                <Comentarios aaff={aaff} />
              </div>
              {aaff?.gruposServicios?.includes(1) &&
                <>
                  <hr />
                  <div className="datosGrid">
    
                    <ObservacionesTecnico aaff={aaff} />
                  </div>
                </>
              }
            </>
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "row-reverse",
              alignItems: "center",
              paddingLeft: 10,
              paddingRight: 10,
              margin: 10,
            }}
          >
          </div>

          <div className="gridSubhead editarSubhead">
            <div>{t('details.communitiesList')}</div>
            {user.rol !== "ADMIN_CAI" && (
              <div className="subheadBtn" onClick={deleteFincas}>
                <span style={{ marginRight: 10 }}>{t('details.deleteFincas')}</span>{" "}
                <img src={Delete} alt={t('common:actions.delete')} />
              </div>
            )}
          </div>
          {user.rol !== "ADMIN_CAI" && (
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: 'center',
              paddingLeft: 10,
              paddingRight: 10,
              marginTop: 20
            }}>
              <div style={{ 
                display: "flex", 
                justifyContent: "space-between", 
                alignItems: 'center', 
                paddingLeft: 10, 
                paddingRight: 10, 
              }}>
                {show ?
                  <ExportarListaFincasAAFF aaff_id={aaff.id} fincas={propertiesCae} />
                  :
                  <button className='bigBtn' onClick={() => setShow(true)}>
                    <img src={Excel} alt={t('details.generateList')} width="30px" /> {t('details.generateList')}
                  </button>
                }
                <ExportarComunidadesSinSenales nif={aaff.nif} />
              </div>

              <div style={{ 
                display: "flex", 
                justifyContent: "space-between", 
                alignItems: 'center', 
                paddingLeft: 10, 
                paddingRight: 10, 
              }}>
                <button className='bigBtn'  onClick={() => {setOpenDrawer(!openDrawer)}}>
                  <MdOutlineMultipleStop /> {t('details.reassignCommunities')}
                </button>
                <button className='bigBtn'  onClick={() => {setOpenDrawerProperties(!openDrawerProperties)}}>
                  <MdOutlineMultipleStop /> {t('details.changeState')}
                </button>
              </div>
              <DrawerAsignComunidades
                anchor={"right"}
                open={openDrawer}
                setOpen={setOpenDrawer}
                aaff_id={aaff.id}
                onSuccess={() => setRecargar(prev => !prev)}
              />
              <DrawerChangeEstados
                anchor={"right"}
                open={openDrawerProperties}
                setOpen={setOpenDrawerProperties}
                aaff_id={aaff.id}
                onSuccess={() => setRecargar(prev => !prev)}
              />
            </div>
          )}
          <div className="tableContainer">
            <ListadoComunidades aaff={aaff} recargarExterno={recargar}/>
          </div>
        </div>
      </div>

    </>
};

export default withRouter(Comunidades);
